/* loaded by smart-asset */
export default "isologo-kalenis~TIrruTIy.png"